/**
 * Ein Mitschrieb für den Sendeknopf.
 *
 * **Weil „manchmal" keine Diagnose ist.** Aus dem Betrieb (#28): „Senden über
 * den Sendeknopf: geht manchmal, manchmal nicht." Drei Anläufe haben an dieser
 * Stelle geraten -- Fokus halten, beim Aufsetzen senden --, und jeder war auf
 * einem der beiden Geräte grün und auf dem anderen nicht. Was fehlt, ist keine
 * weitere Vermutung, sondern die Antwort auf zwei Fragen:
 *
 * 1. **Kommt der Druck überhaupt an?** Verschluckt iOS den Tipp -- das kennt
 *    dieses Projekt schon von der Textauswahl --, steht hier gar nichts.
 * 2. **Und wenn ja, wo bleibt er?** `submit()` hat fünf Ausgänge, an denen es
 *    still zurückgeht: leerer Text, ein Versand läuft noch, ein Foto ist noch
 *    nicht fertig, ein Video ohne Netz, nichts Fertiges dabei.
 *
 * Aufgeschrieben wird deshalb jedes Ereignis am Knopf und jeder Ausgang von
 * `submit()`. Angesehen wird es in *Einstellungen → Tastatur*, unter dem
 * Mitschrieb der Höhen -- dieselbe Stelle, dieselbe Gewohnheit.
 *
 * **Nur im Speicher, nichts geht hinaus.** Ein Neustart der Anwendung leert
 * es; der Weg dorthin ist ein Seitenwechsel und keiner.
 */
export interface Sendeschritt {
  zeit: string
  was: string
}

const VERLAUF: Sendeschritt[] = []
const LAENGE = 20

export function notiere(was: string): void {
  VERLAUF.unshift({ zeit: new Date().toLocaleTimeString('de-DE'), was })
  if (VERLAUF.length > LAENGE) VERLAUF.length = LAENGE
}

/** Der Mitschrieb, neueste zuerst. */
export function sendeVerlauf(): Sendeschritt[] {
  return VERLAUF.slice()
}
